import "../../../constants/index.js";
import { parseQs } from "../../../utils/qs.js";
import { transformWithSpec } from "../../../utils/response.js";
function publicAccVariables(builder) {
  return {
    getPublicAccountVariable: builder.query({
      providesTags: ["account-variables"],
      query: ({ query }) => ({
        url: `/account-variables${parseQs(query)}`,
        method: "GET"
      }),
      transformResponse: transformWithSpec()
    })
  };
}
export {
  publicAccVariables as default
};
